import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUi from "element-ui";
import Vab from "@/utils/vab";
import "@/assets/iconfont/iconfont.css";
import moment from "moment";
import Api from "./api/index.js";
import i18n from "@/i18n";
import { ensureSession } from "@/utils/auth";

Vue.prototype.$api = Api;
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;
Vue.use(ElementUi, { size: "small" });
Vue.use(Vab);

Vue.prototype.bus = new Vue();

Vue.mixin({
  computed: {
    loadingText() {
      return this.$t("common.loading");
    },
  },
  methods: {
    orderStateLabel(state) {
      const map = {
        1: "orderState.pending",
        2: "orderState.arrive",
        3: "orderState.pickup",
        4: "orderState.delivering",
        5: "orderState.completed",
        6: "orderState.cancelled",
      };
      const key = map[state];
      return key ? this.$t(key) : "";
    },
    $confirmDelete(callback) {
      this.$baseConfirm(this.$t("confirm.deleteItem"), null, callback);
    },
  },
});

const PUBLIC_PATHS = ["/login", "/active"];

router.beforeEach(async (to, from, next) => {
  if (PUBLIC_PATHS.includes(to.path)) {
    if (to.path === "/login") {
      const ok = await ensureSession();
      if (ok) {
        return next({ path: to.query.redirect || "/index" });
      }
    }
    return next();
  }

  const ok = await ensureSession();
  if (!ok) {
    return next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  }

  if (to.path === "/active") {
    return next({ path: "/" });
  }

  next();
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
